import { useState } from "react";
import { AlertTriangle, Loader2, Send, X } from "lucide-react";
import { slotLabel, plural } from "./cargoSlots";
import { CargoGroups } from "./CargoGroups";

export const RoutePreview = ({ stops, busy, onDispatch, onClose }) => {
  const [view, setView] = useState("route");
  const unmatched = stops.filter((s) => !s.matched).length;
  return (
    <section data-testid="loading-route-preview" className="rounded-2xl bg-zinc-950 text-white p-4 md:p-5 space-y-4">
      <div className="flex items-start gap-3">
        <div className="mr-auto">
          <p className="text-[10px] font-mono uppercase tracking-widest text-orange-400">Kolejność doręczeń</p>
          <h2 className="font-heading font-black text-lg uppercase">{`Trasa · ${plural(stops.length, "przystanek", "przystanki", "przystanków")}`}</h2>
        </div>
        <button type="button" data-testid="loading-preview-close" onClick={onClose} aria-label="Zamknij podgląd" className="p-2 rounded-xl hover:bg-white/10 transition-colors"><X className="w-4 h-4" /></button>
      </div>
      {unmatched > 0 && <p data-testid="loading-preview-unmatched" className="flex items-start gap-2 text-xs bg-amber-400/15 text-amber-200 rounded-xl p-3"><AlertTriangle className="w-4 h-4 shrink-0" />{`${unmatched} adres(y) poza regułami szablonu — trafią na koniec trasy.`}</p>}
      <div className="inline-flex rounded-xl bg-white/10 p-1" role="tablist">
        {[["route", "Kolejność trasy"], ["cargo", "Według miejsca"]].map(([id, label]) => (
          <button key={id} type="button" role="tab" aria-selected={view === id} data-testid={`loading-preview-view-${id}`} onClick={() => setView(id)} className={`px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-colors ${view === id ? "bg-orange-600 text-white" : "text-zinc-300 hover:text-white"}`}>{label}</button>
        ))}
      </div>
      {view === "cargo" ? <div className="max-h-[50vh] overflow-y-auto pr-1"><CargoGroups stops={stops} dark /></div> : (
      <ol className="stagger space-y-1.5 max-h-[50vh] overflow-y-auto pr-1">
        {stops.map((s, i) => (
          <li key={`${s.final_order}-${i}`} data-testid={`loading-preview-stop-${i}`} className="flex items-center gap-3 rounded-xl bg-white/5 px-3 py-2">
            <span className="w-7 font-mono text-sm font-black text-orange-400">{s.final_order}</span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold truncate">{s.address_text}</p>
              <p className="text-[11px] text-zinc-400 truncate">{s.is_fixed ? "Stały punkt" : s.rule_label}{s.cargo_slot ? ` · Paka: ${slotLabel(s.cargo_slot, s.cargo_bag)}` : ""}</p>
            </div>
            {!s.matched && <span className="text-[10px] font-bold uppercase text-amber-300">poza</span>}
          </li>
        ))}
      </ol>
      )}
      <button type="button" data-testid="loading-dispatch-btn" disabled={busy} onClick={onDispatch} className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-orange-600 hover:bg-orange-500 text-sm font-black uppercase tracking-wider transition-colors disabled:opacity-50">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}Wyślij do Zleceń
      </button>
    </section>
  );
};
